import CheckoutTimer from './CheckoutTimer';

export default CheckoutTimer;
